import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=09a6ad76&scoped=true"
import script from "./newsList.vue?vue&type=script&lang=ts"
export * from "./newsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a6ad76",
  null
  
)

export default component.exports